// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chart {
  display: flex;
  justify-content: center;
}
.Chart__ChartWrapper {
  position: relative;
  display: block;
  width: 40vw;
  max-height: 30rem;
}
.Chart__ChartWrapper--Bar {
  width: 90vw;
}

@media screen and (max-width: 600px) {
  .Chart__ChartWrapper {
    width: 90vw;
  }
}`, "",{"version":3,"sources":["webpack://./libs/features/charts/src/lib/chart.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;AACF;AACE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AACJ;AACI;EACE,WAAA;AACN;;AAKA;EACE;IACE,WAAA;EAFF;AACF","sourcesContent":[".Chart {\n  display: flex;\n  justify-content: center;\n\n  &__ChartWrapper {\n    position: relative;\n    display: block;\n    width: 40vw;\n    max-height: 30rem;\n\n    &--Bar {\n      width: 90vw;\n    }\n\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .Chart__ChartWrapper {\n    width: 90vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
